import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { selectDialog } from '~/selectors'
import actions from '~/actions'
import DialogStyle from './DialogStyle'

class ModalContainer extends React.Component {
  handleClose = (dialog) => () => {
    this.props.removeDialog(dialog.id)

    if (this.props.config.showContextViewStore) {
      this.props.updateApp({ storesLoading: false })
    } else {
      dialog.navigate
        ? this.props.history.push({
            pathname: '/busca',
            search: `?q=${dialog.navigate}`,
          })
        : this.props.history.push('/')
    }
  }

  renderDialog = (dialog) => (
    <DialogStyle
      key={dialog.id}
      product={dialog.product}
      open={dialog.open}
      ecommerce={dialog.config}
      handleClose={this.handleClose(dialog)}
      {...this.props}
    />
  )

  render() {
    return this.props.dialogs.map(this.renderDialog)
  }
}

const mapStateToProps = selectDialog
const mapDispatchToProps = (dispatch) => ({
  removeDialog: (id) => dispatch(actions.dialog.remove(id)),
  updateApp: (payload) => dispatch(actions.updateApp(payload)),
})

const enhance = compose(connect(mapStateToProps, mapDispatchToProps))

export default enhance(withRouter(ModalContainer))
